import React from "react";
import { Link } from "react-router-dom";
import SemButton from "../../../common/components/Button";

const BlurCard = ({ redirectPath, useBtn, onActionCall }) => {
  return (
    <div className="blur-card-wth-btn">
      {useBtn ? (
        <SemButton
          name="View"
          // onClick={onActionCall}
          size="m"
          color="#365486"
        />
      ) : (
        <Link to={redirectPath}>
          <SemButton name="View" size="m" color="#365486" />
        </Link>
      )}
    </div>
  );
};

export default BlurCard;
